import { useCallbackOne } from "use-memo-one";

import { useOrganization } from "../components/organizations/OrganizationProvider";
import { SalesDataItem } from "../components/sales-data/SalesDataPage";
import usePromise from "../components/utils/usePromise";
import { useDataStore } from "./index";

export interface SalesDataResponse {
  recipes: SalesDataItem[];
  timePeriod: {
    year: number;
    periodType: string;
    month: number | null;
    quarter: number | null;
    halfYear: number | null;
  };
}

export interface SalesDataError {
  code: string;
}

export default function useSalesData(filterParams = "") {
  const dataStore = useDataStore();
  const [dashboardOrganization] = useOrganization();

  const load = useCallbackOne(async () => {
    try {
      return await dataStore.fetchSalesData(
        dashboardOrganization.id,
        filterParams
      );
    } catch (error) {
      // Check if this is the specific error type we're looking for
      if (
        error instanceof Error &&
        error.message.includes("unexpected status code: 500")
      ) {
        // Try to extract the error code if possible
        return { error: { code: "CACHED_IMPACT_NOT_FOUND" } as SalesDataError };
      }
      throw error; // Re-throw other errors
    }
  }, [dataStore, dashboardOrganization, filterParams]);

  return usePromise(load);
}
